
export class WinnerL3rd {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "WinnerL3rd";
    this.scene = "WinnerL3rd";
    this.data = [];
    this.page = 105;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {
      xml.payload.field.find((item) => {
        return item.attr.name === "102";
      }).value = (options?.game?.winner?.first_name.toUpperCase()  || "");
      
      xml.payload.field.find((item) => {
        return item.attr.name === "103";
      }).value = (options?.game?.winner?.last_name.toUpperCase()  || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "10401";
      }).value = "AGE " + (options?.game?.winner?.age || "");     
      
      xml.payload.field.find((item) => {
        return item.attr.name === "200";
      }).value = "WINNER BY " + (options?.game?.winnerby || "");
  
      xml.payload.field.find((item) => {
        return item.attr.name === "300";
      }).value = "NEW RECORD:";

      xml.payload.field.find((item) => {
        return item.attr.name === "301";
      }).value = "WON " + (parseInt(options?.game?.winner?.wins) + 1);

      xml.payload.field.find((item) => {
        return item.attr.name === "302";
      }).value = "LOST " + (options?.game?.winner?.losses || "");

      xml.payload.field.find((item) => {
        return item.attr.name === "303";
      }).value = "DRAWN " + (options?.game?.winner?.draws || "");

      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
